import { type ImgData } from "../../utils/models";
import { type FullNavData } from "./loadNavigationEpic";
import { type NavigationNode } from "../types";
import { type SearchDisplayMode, type SRPSeriesTreeNode } from "../../Search/models";

export const BEGIN_LOADING_NAVIGATION = "Navigation: load from api";
export const LOADING_SUCCESS = "Navigation: load to storage";
export const SELECT_NAV = "SELECT_NAV";
export const GO_BACK = "Navigation: go back one level";
export const CLOSE_NAVIGATION = "CLOSE_NAVIGATION";
export const SELECT_NAV_IMAGE = "SELECT_NAV_IMAGE";
export const CHANGE_NAVIGATION_MODE = "Navigation: change display mode";
export const NAVIGATION_LOAD_SERIES_DATA = "Navigation: load series data";
export const NAVIGATION_SERIES_TOGGLE_NODE = "Navigation: toggle series tree node";

export function beginLoadingAction() {
  return {
    type: BEGIN_LOADING_NAVIGATION,
  } as const;
}

export function loadingSuccessAction(data: FullNavData) {
  return {
    type: LOADING_SUCCESS,
    payload: data,
  } as const;
}

export function closeNavigationAction() {
  return {
    type: CLOSE_NAVIGATION,
  } as const;
}

export function selectNavigationAction(node: NavigationNode) {
  return {
    type: SELECT_NAV,
    payload: { nodeId: node.id, level: node.level },
  } as const;
}

export function navigationGoBack() {
  return {
    type: GO_BACK,
    payload: "",
  } as const;
}

export function selectNavigationImage(img?: ImgData) {
  return {
    type: SELECT_NAV_IMAGE,
    payload: img,
  } as const;
}

export function changeNavigationDisplayMode(mode: SearchDisplayMode) {
  return {
    type: CHANGE_NAVIGATION_MODE,
    payload: mode,
  } as const;
}

export function loadNavigationSeriesTreeData(data: SRPSeriesTreeNode[]) {
  return {
    type: NAVIGATION_LOAD_SERIES_DATA,
    payload: data,
  } as const;
}

export function navigationToggleSeriesTreeNodeAction(nodeId: string, isExpanded: boolean) {
  return {
    type: NAVIGATION_SERIES_TOGGLE_NODE,
    payload: {
      nodeId,
      isExpanded,
    },
  } as const;
}

export type NavigationActions =
  | ReturnType<typeof beginLoadingAction>
  | ReturnType<typeof loadingSuccessAction>
  | ReturnType<typeof selectNavigationAction>
  | ReturnType<typeof selectNavigationImage>
  | ReturnType<typeof closeNavigationAction>
  | ReturnType<typeof navigationGoBack>
  | ReturnType<typeof changeNavigationDisplayMode>
  | ReturnType<typeof loadNavigationSeriesTreeData>
  | ReturnType<typeof navigationToggleSeriesTreeNodeAction>;
